import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';
import LoaderGridTimeTurn from '../../admission/loading/LoaderGridTimeTurn';

const TurnPreviewSkeleton = () => {
    return (
        <div className="w-full mt-3"> 
            <div className="flex justify-between items-center">
                <Skeleton className="!rounded-md w-16 h-6" />
                <Skeleton className="!rounded-md w-24 h-6" />
            </div>
            <div className="flex gap-4 items-center mt-4">
                <div className="bg-accent !rounded-2xl p-2 flex flex-col justify-center items-center gap-1 w-full h-20">
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-6" />
                </div>
                <div className="bg-accent !rounded-2xl p-2 flex flex-col justify-center items-center gap-1 w-full h-20">
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-6" />
                </div>
                <div className="bg-accent !rounded-2xl p-2 flex flex-col justify-center items-center gap-1 w-full h-20">
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-6" />
                </div>
                <div className="bg-accent !rounded-2xl p-2 flex-col sm:!flex hidden justify-center items-center gap-1 w-full h-20">
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-4" />
                    <Skeleton className="!rounded-md bg-gray-200 w-3/4 mx-auto h-6" />
                </div>
            </div>
            <hr className="border-dashed border-2 border-gray-200 my-3" />
            <Skeleton className="!rounded-md w-16 h-6 mb-3" />
            <LoaderGridTimeTurn />
        </div>
    );
};

export default TurnPreviewSkeleton;
